import { Component, OnInit } from '@angular/core';
import { UserGroup} from '../../../_models/user_group';
import { UserZone} from '../../../_models/user_zone';
import { Zone} from '../../../_models/zone';
import * as fromUserGroup from '../../../userGroup/state/userGroup.reducer';
import * as userGroupActions from '../../../userGroup/state/userGroup.actions';
import * as fromRoot from '../../../state/app.reducer';
import * as rootActions from '../../../state/app.actions';
import { Store, select } from '@ngrx/store';
// import { takeWhile } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
  templateUrl: './userGroup-edit-shell.component.html'
})

export class UserGroupEditShellComponent implements OnInit {

  // errorMessage$: Observable<string>;
  currentUserGroup$: Observable<UserGroup>
  zoneUserList$: Observable<UserZone[]>;
  zoneList$: Observable<Zone[]>;

  constructor(
    private storeRoot: Store<fromRoot.State>,
    private store: Store<fromUserGroup.State>
  ) {}

  ngOnInit() {

    this.currentUserGroup$ = this.store.pipe(select(fromUserGroup.getCurrentUserGroup)) as Observable<UserGroup>;
    this.zoneUserList$ = this.store.pipe(select(fromUserGroup.getUserZoneList)) as Observable<UserZone[]>;
    this.zoneList$ = this.store.pipe(select(fromUserGroup.getZoneList)) as Observable<Zone[]>;

  }

  // NOTA: Las funciones realmente deberían quedar con una simple instrucción "dispatch".
  saveUserGroup(userGroupIn: UserGroup): void {

    console.log('---> saveUserGroup userGroupIn:');
    console.log(userGroupIn);

    if (userGroupIn.id === null) {
      console.log('Se va a CREAR un nuevo grupo.');
      this.store.dispatch( new userGroupActions.CreateUserGroup(userGroupIn));
    } else {
      console.log('Se va a MODIFICAR un grupo existente.');
      this.store.dispatch( new userGroupActions.UpdateUserGroup(userGroupIn));
    }
  }

  deleteUserZone(userZoneIn: UserZone): void {

    console.log('---> deleteUserZone: ');
    console.log(userZoneIn);

    this.store.dispatch( new userGroupActions.DeleteUserZone(userZoneIn));

  } // End function deleteUserZone

  addUserZone(userZoneIn: UserZone): void {

    console.log('---> addUserZone: ');
    console.log(userZoneIn);

    this.store.dispatch( new userGroupActions.CreateUserZone(userZoneIn));

  } // End function addUserZone

  // --------------------------------------------------------------
  // Función para mostrar la ventana genérica de información.
  showInfoModal(modalParams) {

    console.log('---->>>>.... Ejecutando prodData-edit-shell showInfoModal: '
    + modalParams.value + ' ;Info: ' + modalParams.info + ' ;Link: ' + modalParams.link + ' ;Skin: ' + modalParams.skin);

    this.storeRoot.dispatch( new rootActions.ChangeInfoModal({
      value: modalParams.value,
      info: modalParams.info,
      link: modalParams.link,
      param: modalParams.param,
      skin: modalParams.skin
    }));

  } // End function showInfoModal


} // End class UserGroupEditShellComponent
